import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AnalyticsService } from '../../core/services/analytics.service';
import { ILandingConfig, LandingConfigs, LandingService } from '../../core/services/landing.service';
import { SeoService } from '../../core/services/seo.service';
import { ToolsService } from '../../core/services/tools.service';
import { HelpModalComponent } from '../../shared/modals/help-modal/help-modal.component';
import { IntlService } from '../../core/services/intl.service';
import { Subscription } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-calendar-page',
  templateUrl: './calendar-page.component.html',
  styleUrls: ['./../landing.component.scss'],
})
export class CalendarPageComponent {
  public landing: ILandingConfig;

  public language;
  public host;
  public supportEmail;
  public salesPhone;
  public bsModalRef: BsModalRef;
  public showVideo = false;
  public showMobileNav = false;

  public languageSubscription: Subscription;

  constructor(
    public toolsService: ToolsService,
    private modalService: BsModalService,
    private landingService: LandingService,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
    private intlService: IntlService
  ) {}

  ngOnInit() {
    this.language = this.intlService.getCurrentLanguage();
    this.host = this.intlService.getHost();

    this.getLandingConfig();
    this.languageSubscription = this.intlService.languageChanged().subscribe((lang) => {
      this.language = lang;
      this.getLandingConfig();
    });
  }

  getLandingConfig() {
    this.supportEmail = this.intlService.getSupportEmail();
    this.salesPhone = this.intlService.getContactPhone();

    const activeConfig: LandingConfigs = this.activatedRoute.snapshot.data.config || LandingConfigs.GENERAL;
    this.translate.getTranslation(this.translate.currentLang).subscribe((res) => {
      this.landing = this.landingService.getLandingConfig(activeConfig, res);
      this.setMetaTags(this.landing);
    });
  }

  showVideoOverlay() {
    this.showVideo = !this.showVideo;
  }

  showHelpModal() {
    this.bsModalRef = this.modalService.show(HelpModalComponent, { class: 'modal-md' });
  }

  setMetaTags(data: ILandingConfig) {
    const title = 'BUK | ' + data.pageTitle;
    const description = data.pageDescription;
    const image = data.pageOgImage[this.language];
    this.seoService.setMetaTags(title, description, image);
  }

  analyticsEvent(action, category = 'calendarPage') {
    this.analytics.trackEvent(action, category);
  }

  toggleMobileNav() {
    this.showMobileNav = !this.showMobileNav;
  }

}
